import { PaymentMethod, SplitOption } from "./types";

export { LANGUAGE_CODES } from "../shared/constants";

// ─── Default payment methods ───────────────────────────
export const DEFAULT_PAYMENT_METHODS: PaymentMethod[] = [
    {
        id: "online",
        icon:
            "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z",
        title: {
            fr: "Paiement en ligne",
            en: "Online payment",
            es: "Pago en línea",
            it: "Pagamento online",
            nl: "Online betaling",
            pt: "Pagamento online",
            de: "Online-Zahlung",
            ar: "الدفع عبر الإنترنت",
            ru: "Онлайн-оплата",
        },
        description: {
            fr: "Payer directement par carte bancaire",
            en: "Pay directly by credit card",
            es: "Pagar directamente con tarjeta bancaria",
            it: "Pagare direttamente con carta bancaria",
            nl: "Direct betalen met bankkaart",
            pt: "Pagar diretamente com cartão bancário",
            de: "Direkt mit Bankkarte bezahlen",
            ar: "ادفع مباشرة ببطاقة الائتمان",
            ru: "Оплатить банковской картой",
        },
        enabled: true,
    },
    {
        id: "tpe",
        icon:
            "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z",
        title: {
            fr: "Paiement par CB (TPE)",
            en: "Card payment (TPE)",
            es: "Pago con tarjeta (TPE)",
            it: "Pagamento con carta (TPE)",
            nl: "Kaartbetaling (TPE)",
            pt: "Pagamento com cartão (TPE)",
            de: "Kartenzahlung (TPE)",
            ar: "الدفع بالبطاقة (TPE)",
            ru: "Оплата картой (TPE)",
        },
        description: {
            fr: "Le serveur apportera le TPE",
            en: "The server will bring the card reader",
            es: "El camarero traerá el TPE",
            it: "Il cameriere porterà il TPE",
            nl: "De ober brengt de kaartlezer",
            pt: "O empregado trará o TPE",
            de: "Der Kellner bringt das Kartenlesegerät",
            ar: "سيحضر النادل قارئ البطاقات",
            ru: "Официант принесёт терминал",
        },
        enabled: true,
    },
    {
        id: "cash",
        icon:
            "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z",
        title: {
            fr: "Paiement en espèces",
            en: "Cash payment",
            es: "Pago en efectivo",
            it: "Pagamento in contanti",
            nl: "Contante betaling",
            pt: "Pagamento em dinheiro",
            de: "Barzahlung",
            ar: "الدفع نقداً",
            ru: "Оплата наличными",
        },
        description: {
            fr: "Payer en espèces au serveur",
            en: "Pay in cash to the server",
            es: "Pagar en efectivo al camarero",
            it: "Pagare in contanti al cameriere",
            nl: "Contant betalen aan de ober",
            pt: "Pagar em dinheiro ao empregado",
            de: "Bar beim Kellner bezahlen",
            ar: "ادفع نقداً للنادل",
            ru: "Оплатить наличными официанту",
        },
        enabled: true,
    },
];

// ─── Default split options ─────────────────────────────
export const DEFAULT_SPLIT_OPTIONS: SplitOption[] = [
    {
        id: "equal",
        icon:
            "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z",
        title: {
            fr: "Diviser équitablement",
            en: "Split equally",
            es: "Dividir equitativamente",
            it: "Dividere equamente",
            nl: "Gelijk verdelen",
            pt: "Dividir igualmente",
            de: "Gleichmäßig aufteilen",
            ar: "تقسيم بالتساوي",
            ru: "Разделить поровну",
        },
        description: {
            fr: "Entre les personnes à la table",
            en: "Between people at the table",
            es: "Entre las personas en la mesa",
            it: "Tra le persone al tavolo",
            nl: "Tussen de mensen aan tafel",
            pt: "Entre as pessoas na mesa",
            de: "Zwischen den Personen am Tisch",
            ar: "بين الأشخاص على الطاولة",
            ru: "Между людьми за столом",
        },
        enabled: true,
    },
    {
        id: "by_item",
        icon:
            "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z",
        title: {
            fr: "Par article",
            en: "By item",
            es: "Por artículo",
            it: "Per articolo",
            nl: "Per artikel",
            pt: "Por artigo",
            de: "Nach Artikel",
            ar: "حسب المنتج",
            ru: "По товару",
        },
        description: {
            fr: "Sélectionner vos articles",
            en: "Select your items",
            es: "Seleccionar sus artículos",
            it: "Selezionare i propri articoli",
            nl: "Selecteer uw artikelen",
            pt: "Selecionar os seus artigos",
            de: "Wählen Sie Ihre Artikel",
            ar: "حدد عناصرك",
            ru: "Выберите товары",
        },
        enabled: true,
    },
    {
        id: "custom",
        icon:
            "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z",
        title: {
            fr: "Montant personnalisé",
            en: "Custom amount",
            es: "Monto personalizado",
            it: "Importo personalizzato",
            nl: "Aangepast bedrag",
            pt: "Montante personalizado",
            de: "Benutzerdefinierter Betrag",
            ar: "مبلغ مخصص",
            ru: "Произвольная сумма",
        },
        description: {
            fr: "Entrer votre montant",
            en: "Enter your amount",
            es: "Ingrese su monto",
            it: "Inserire l'importo",
            nl: "Voer uw bedrag in",
            pt: "Introduza o seu montante",
            de: "Geben Sie Ihren Betrag ein",
            ar: "أدخل المبلغ",
            ru: "Введите сумму",
        },
        enabled: true,
    },
];
